export default __webpack_public_path__ + "static/media/5082_bp.f537ce5d.svg";